import { useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import textContentSmarthomeContactUsSection from "../ui/textContent-smarthome-contactUsSection";
import commandMod from "../../../assets/products/COMMAND_1.png";
import refaireSansDefaireImage from "../../../assets/smarthome/Refaire_sans_défaire.jpg";

export default function ReuseExistingSection(props) {
  const { textContent, language } = { ...props };

  const screenWidth = useSelector((state) => state.screen.screenWidth);
  const isMobile = useSelector((state) => state.screen.isMobile);

  const deviceCard = (title, subtitle, image, productURL) => {
    return (
      <div className={`command1-item ${isMobile ? "mobile" : ""}`}>
        <h3 className="h3-bold h3-command1-item">{title}</h3>
        <h4 className="h4-command1-item">{subtitle}</h4>
        <img
          src={image}
          aria-hidden="true"
          // className="automation-item-icon"
        />
        <a href={productURL} className="learn-more-button">
          {
            textContentSmarthomeContactUsSection.learnMoreSection.title[
              language
            ]
          }
        </a>
      </div>
    );
  };

  const textInfo = (
    title,
    description1,
    description2,
    conclusion,
    removeLeftMargin,
  ) => {
    return (
      <div
        className={`reuse-text ${isMobile ? "mobile" : ""} ${removeLeftMargin ? "removeLeftMargin" : ""}`}
      >
        <h2 className="h2-bold">{title}</h2>
        <p>{description1}</p>
        <p
          dangerouslySetInnerHTML={{
            __html: description2,
          }}
        />

        <h3 className="h3-bold">{conclusion}</h3>
        <div
          className={
            isMobile ? "container-empty-extra-small" : "container-empty-small"
          }
        />
      </div>
    );
  };

  return (
    <section className="container">
      <div className="container-small">
        <h1 className="title-gradient">
          {textContent.productSection.items.switches.title[language]}
        </h1>
      </div>
      <div className={isMobile ? "" : "container-empty-extra-small"} />
      <div className={isMobile ? "reuse-content-mobile" : "reuse-content"}>
        {textInfo(
          textContent.productSection.items.switches.functions.noWork.title[
            language
          ],
          textContent.productSection.items.switches.functions.noWork.subtitle[
            language
          ],

          textContent.productSection.items.switches.functions.noWork
            .description[language],

          textContent.productSection.items.switches.functions.noWork.conclusion[
            language
          ],
        )}
        {deviceCard(
          textContent.productSection.items.switches.functions.commandModule
            .title[language],
          textContent.productSection.items.switches.functions.commandModule
            .description[language],
          commandMod,
          textContent.productSection.items.products.productsList.COMMAND_1.link,
        )}
      </div>
      <div className={isMobile ? "reuse-content-mobile" : "reuse-content"}>
        {isMobile ? null : (
          <div className="refaireSansDefaireImage">
            <img src={refaireSansDefaireImage} aria-hidden="true" />
          </div>
        )}
        {textInfo(
          textContent.productSection.items.switches.functions.noDemolition
            .title[language],
          textContent.productSection.items.switches.functions.noDemolition
            .description[language],

          "",

          textContent.productSection.items.switches.functions.noDemolition
            .conclusion[language],
          isMobile ? false : true,
        )}
        {isMobile ? (
          <div className="refaireSansDefaireImage mobile">
            <img src={refaireSansDefaireImage} aria-hidden="true" />
          </div>
        ) : null}
      </div>
    </section>
  );
}
